import React from "react";
import OrdersPage from "Common/Components/OrdersPage";

// سفارش‌های خارج شده از انبار = سفارش‌هایی که order_status آن‌ها out_of_warehouse است.
// همه‌ی عملیات روی ردیف‌های قلم انجام می‌شوند.
const Index = () => (
  <OrdersPage
    pageTitle="سفارش‌های خارج شده از انبار"
    orderStatus="out_of_warehouse"
    canRevert
    revertRoles={[]}
    emptyText="هیچ سفارشی خارج‌شده از انبار نیست"
  />
);

export default Index;
